module.exports = __webpack_public_path__ + "img/set-up-initial-promotion.e7fe8f33.svg";